import React from 'react';

const AnchorWrapper = ({
                         children,
                         onMouseEnter,
                         onMouseLeave,
                         onClick,
                         popperId,
                       }: {
  children: React.ReactNode;
  onMouseEnter: (event: React.MouseEvent<HTMLElement>) => void;
  onMouseLeave: () => void;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  popperId: string | undefined;
}) => {
  return (
    <div
      aria-describedby={popperId}
      onMouseEnter={onMouseEnter}
      onClick={onClick}
      onMouseLeave={onMouseLeave}
      style={{ cursor: 'pointer' }}
    >
      {children}
    </div>
  );
};

export default AnchorWrapper;
